import builder from '../builder';
import LightBulb2 from '../../streamline-icons/light/light-bulb-2.svg';

export default builder('IconLightBulb2Light', LightBulb2);
